<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h1>Cadastro de examinadores externos</h1>
    <button
      mat-stroked-button
      *ngIf="concursoFixo"
      (click)="navegarListaExaminadores()">
      <mat-icon>groups</mat-icon> Ver Examinadores
    </button>
  </div>
  <mat-card>
    <mat-card-content>
      <form [formGroup]="formConsultaExaminadorExterno" fxLayout="column" fxLayoutAlign="start" class="mb-2">
        <mat-radio-group
          formControlName="tipoDocumento"
          fxLayout="row"
          fxLayoutGap="20px"
          class="mb-16"
          color="primary"
          [disabled]="hasSearched">
          <mat-radio-button value="cpf">CPF</mat-radio-button>
          <mat-radio-button value="passaporte">Passaporte</mat-radio-button>
        </mat-radio-group>
        <mat-form-field
          appearance="outline"
          *ngIf="formConsultaExaminadorExterno.get('tipoDocumento')?.value === 'cpf'">
          <mat-label>CPF</mat-label>
          <input
            matInput
            formControlName="cpf"
            required
            maxlength="11"
            mask="00000000000"
            (keydown.enter)="queryExaminadorExterno()" />
          <mat-hint>Informe o CPF</mat-hint>
          <mat-error
            *ngIf="
              formConsultaExaminadorExterno.get('cpf')?.invalid && formConsultaExaminadorExterno.get('cpf')?.touched
            ">
            CPF Inválido
          </mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          *ngIf="formConsultaExaminadorExterno.get('tipoDocumento')?.value === 'passaporte'">
          <mat-label>Passaporte</mat-label>
          <input
            matInput
            formControlName="passaporte"
            required
            maxlength="18"
            (keydown.enter)="queryExaminadorExterno()" />
          <mat-hint>Informe o número do passaporte</mat-hint>
          <mat-error
            *ngIf="
              formConsultaExaminadorExterno.get('passaporte')?.invalid &&
              formConsultaExaminadorExterno.get('passaporte')?.touched
            ">
            Passaporte Inválido
          </mat-error>
        </mat-form-field>
        <mat-card *ngIf="hasSearched && !existingExaminador" class="card-warning">
          Examinador não encontrado, será necessário realizar seu cadastro
        </mat-card>
        <mat-card *ngIf="existingExaminador" class="card-warning"> Examinador possui cadastro </mat-card>
      </form>
      <form [formGroup]="formCadastroExaminadorExterno" fxLayout="column" fxLayoutGap="5px" *ngIf="hasSearched">
        <fieldset fxFlex="100%">
          <legend>Dados pessoais do examinador</legend>
          <div fxLayout.gt-sm="row" fxLayoutGap="20px">
            <mat-form-field appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput formControlName="nome" required maxlength="40" />
              <mat-hint> Informe o nome completo</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput formControlName="email" />
              <mat-hint>Informe um Email pessoal do examinador</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Instituição de ensino</mat-label>
              <input matInput formControlName="instituicao" required maxlength="160" />
              <mat-hint> Informe instituição onde examaminador trabalha</mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Data de nascimento</mat-label>
              <input
                matInput
                readonly=""
                [matDatepicker]="pickerInicio"
                formControlName="dataNascimento"
                name="dataNascimento" />
              <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
              <mat-datepicker #pickerInicio></mat-datepicker>
              <mat-hint> Informe a data de nascimento</mat-hint>
            </mat-form-field>
          </div>
        </fieldset>
        <fieldset>
          <div fxLayout.gt-sm="row" fxLayoutGap="20px" class="pb-10">
            <inscricoes-autocomplete-key-value
              [options]="paises"
              keyProperty="sigla"
              valueProperty="pais"
              label="País"
              placeholder="Digite para buscar..."
              formControlName="siglaPais"
              appearance="outline"
              fxFlex>
            </inscricoes-autocomplete-key-value>

            <mat-form-field appearance="outline">
              <mat-label>Idioma</mat-label>
              <mat-select formControlName="idiomaComunicacao" required>
                <mat-option value="pt">Português</mat-option>
                <mat-option value="en">Inglês</mat-option>
              </mat-select>
              <mat-hint>Idioma de notificação do SiSe </mat-hint>
            </mat-form-field>
          </div>
        </fieldset>
        <fieldset fxFlex="100%" class="spacing-top">
          <legend>Documentos do examinador</legend>
          <mat-card *ngIf="!isBrasileiro" class="card-warning">
            Para examinador estrangeiro é obrigatório informar ao menos um dos documentos abaixo</mat-card
          >
          <mat-card *ngIf="isBrasileiro" class="card-warning">
            Para examinador brasileiro é obrigatório informar apenas o CPF, sendo os demais campos opcionais</mat-card
          >
          <div fxLayout.gt-sm="row" fxLayoutGap="20px">
            <mat-form-field
              appearance="outline"
              *ngIf="
                formConsultaExaminadorExterno.get('tipoDocumento')?.value === 'passaporte' &&
                formCadastroExaminadorExterno.get('siglaPais')?.value.sigla === 'BR'
              ">
              <mat-label>CPF</mat-label>
              <input
                matInput
                formControlName="cpf"
                required
                maxlength="11"
                mask="00000000000"
                (keydown.enter)="queryExaminadorExterno()" />
              <mat-hint>Informe o CPF</mat-hint>
              <mat-error
                *ngIf="
                  formCadastroExaminadorExterno.get('cpf')?.invalid && formCadastroExaminadorExterno.get('cpf')?.touched
                ">
                CPF Inválido
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>RG</mat-label>
              <input matInput formControlName="rg" maxlength="18" />
              <mat-hint> Informe o número do Registro Geral (RG) </mat-hint>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              *ngIf="formConsultaExaminadorExterno.get('tipoDocumento')?.value === 'cpf'">
              <mat-label>Passaporte</mat-label>
              <input matInput formControlName="passaporte" maxlength="18" />
              <mat-hint> Informe o número do passaporte </mat-hint>
            </mat-form-field>
          </div>
        </fieldset>
        <fieldset *ngIf="!isBrasileiro">
          <div fxLayout.gt-sm="row" fxLayoutGap="20px" fxFill class="pb-10">
            <mat-form-field appearance="outline">
              <mat-label>RNE</mat-label>
              <input matInput formControlName="rne" maxlength="18" />
              <mat-hint> Informe o número do Registro Nacional de Estrangeiros (RNE) </mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Tipo do documento estrangeiro</mat-label>
              <input matInput formControlName="tipoDocEstrangeiro" maxlength="15" />
              <mat-hint>
                Caso o examinador não tenha outros documentos, informe um outro tipo de documento estrangeiro (o campo
                não aceita RG, CPF, RNE ou Passaporte)
              </mat-hint>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Documento estrangeiro</mat-label>
              <input matInput formControlName="numeroDocEstrangeiro" maxlength="30" />
              <mat-hint>
                Informe o número do outro tipo de documento estrangeiro (não pode ser igual ao número do RG, CPF, RNE ou
                Passaporte)
              </mat-hint>
            </mat-form-field>
          </div>
        </fieldset>
      </form>
      <form
        [formGroup]="formAceiteExaminadorExterno"
        fxLayout="column"
        fxLayoutGap="5px"
        *ngIf="existingExaminador || hasSearched">
        <fieldset fxFlex="100%" class="spacing-top">
          <table-provas-ativas-examinador
            *ngIf="existingExaminador && examinadorExternoConsulta.concursosProvasData.length > 0"
            [concursosProvasData]="examinadorExternoConsulta.concursosProvasData" />
        </fieldset>
        <fieldset fxFlex="100%" class="spacing-top">
          <legend>Dados do concurso</legend>
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline" fxFlex.gt-md="50%">
              <mat-label>Papel</mat-label>
              <mat-select formControlName="papel" name="papel">
                <mat-option value="TITULAR">Examinador titular</mat-option>
                <mat-option value="SUPLENTE">Examinador suplente</mat-option>
              </mat-select>
              <mat-hint>Papel que a pessoa irá exercer no concurso.</mat-hint>
            </mat-form-field>
            <inscricoes-autocomplete-key-value
              [options]="concursosAtivos"
              keyProperty="id"
              valueProperty="titulo"
              label="Concurso"
              placeholder="Digite para buscar..."
              hint="Concurso em que a pessoa será examinador."
              formControlName="concurso"
              appearance="outline"
              fxFlex>
            </inscricoes-autocomplete-key-value>
          </div>
        </fieldset>
        <fieldset fxFlex="100%" class="spacing-top">
          <legend>Termo de ciência</legend>
          <mat-card class="card-warning">
            Estou ciente de que serei o responsável por esta conta de usuário, podendo a partir do site SiSe Admin
            alterar informações do cadastro deste usuário criado conforme necessário, bem como a data de expiração dessa
            conta conforme homologação do concurso ou término da fase de avaliação.
          </mat-card>
          <div fxLayout="row" fxLayoutAlign="center center">
            <mat-checkbox color="primary" formControlName="deAcordo" name="deAcordo"> De acordo </mat-checkbox>
          </div>
        </fieldset>
      </form>
    </mat-card-content>

    <mat-card-actions align="end">
      <div
        fxLayoutAlign.gt-md="end center"
        fxLayoutAlign.lt-md="center stretch"
        fxLayout.lt-md="column"
        fxLayoutGap="20px">
        <button
          mat-stroked-button
          (click)="navegarListaExaminadores()"
          *ngIf="concursoFixo && !hasSearched">
          <mat-icon>groups</mat-icon> Ver Examinadores
        </button>
        <button
          *ngIf="!hasSearched"
          mat-raised-button
          color="primary"
          [disabled]="formConsultaExaminadorExterno.invalid"
          (click)="queryExaminadorExterno()">
          <mat-icon>add</mat-icon> Consultar
        </button>

        <button
          mat-stroked-button
          (click)="navegarListaExaminadores()"
          *ngIf="concursoFixo && hasSearched">
          <mat-icon>groups</mat-icon> Ver Examinadores
        </button>

        <button
          mat-raised-button
          color="primary"
          [disabled]="formCadastroExaminadorExterno.invalid || formAceiteExaminadorExterno.invalid"
          (click)="onSubmit()"
          *ngIf="hasSearched">
          <mat-icon>add</mat-icon> Cadastrar
        </button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>
